/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import FooterTableCell from "./FooterTableCell";
import FooterTableRow from "./FooterTableRow";
import LinkButton from "../controls/LinkButton";
import DiscountPopup from "./DiscountPopup";
import TaxPopup from "./TaxPopup";

class TaxDiscountRow extends Component {
  state = {
    showDiscount: false,
    showTax: false
  };

  toggleDiscount = () => {
    this.setState({ showDiscount: !this.state.showDiscount });
  };

  toggleTax = () => {
    this.setState({ showTax: !this.state.showTax });
  };

  render() {
    const { cartArray, summary } = this.props;

    const discountText = `\u20A6${Number(
      summary.discountOnItems || 0
    ).toLocaleString()} (\u20A6${Number(
      summary.discountOnTotal || 0
    ).toLocaleString()})`;

    const { taxAmount, tax } = summary;
    const { showDiscount, showTax } = this.state;

    return (
      <Fragment>
        <DiscountPopup
          summary={summary}
          cartArray={cartArray}
          close={this.toggleDiscount}
          open={showDiscount}
        />

        <TaxPopup
          tax={summary.tax}
          open={showTax}
          close={this.toggleTax}
        />

        <FooterTableRow
          style={{
            background: "#fbfdfc",
            borderTop: "1px solid #edf2f0"
          }}
        >
          <FooterTableCell
            numeric
            style={{
              width: "150px",
              paddingTop: 10,
              paddingBottom: 10
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "5px 9px",
                borderRadius: 8,
                background: "#fff7ed",
                color: "#c2410c",
                fontSize: 11,
                fontWeight: 800
              }}
            >
              <LinkButton
                text="Discount"
                onClick={this.toggleDiscount}
              />
            </span>
          </FooterTableCell>

          <FooterTableCell
            numeric
            style={{
              color: "#c2410c",
              fontSize: 12,
              fontWeight: 700
            }}
          >
            {discountText}
          </FooterTableCell>

          <FooterTableCell numeric />

          <FooterTableCell
            style={{
              paddingLeft: "15px",
              color: "#315f86",
              fontSize: 12,
              fontWeight: 700
            }}
          >
            <LinkButton
              text={`Tax (${tax}%)`}
              onClick={this.toggleTax}
            />
          </FooterTableCell>

          <FooterTableCell
            numeric
            style={{
              color: "#315f86",
              fontSize: 12,
              fontWeight: 700
            }}
          >
            {"\u20A6"}{Number(taxAmount || 0).toLocaleString()}
          </FooterTableCell>
        </FooterTableRow>
      </Fragment>
    );
  }
}

export default TaxDiscountRow;
